import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from 'react-query'

import * as spriteIcons from 'assets/svg/sprite'
import { addToast } from 'components/Toast/Toast'
import { ActionCard } from 'components-ref/molecules/ActionCard/ActionCard'
import LayoutHeader from 'features/LayoutHeader/LayoutHeader'
import WithHeaderSection from 'layouts/WithHeaderSection/WithHeaderSection'
import { setActivity } from 'services/endpoints/settings/general/activity'
import { useUserProfile } from 'store'
import { type ActivitySettings } from 'types/api/settings'

export const Activity = () => {
    const { t } = useTranslation()
    const userData = useUserProfile()!

    const queryClient = useQueryClient()

    const activitySettingsMutation = useMutation(
        async (data: ActivitySettings) => await setActivity(data),
        {
            onMutate: async data => {
                await queryClient.cancelQueries('user-profile')
                const previousQueryData =
                    queryClient.getQueryData('user-profile')
                queryClient.setQueryData('user-profile', (oldData: any) => {
                    return {
                        ...oldData,
                        show_liked_history: data.showLikeHistory,
                        show_watched_history: data.showWatchedHistory
                    }
                })
                return { previousQueryData }
            },
            onError: (error, _, context: any) => {
                console.error(error)
                queryClient.setQueryData(
                    'user-profile',
                    context.previousQueryData
                )
                addToast('error', 'Something went wrong')
            }
        }
    )

    return (
        <WithHeaderSection
            headerSection={
                <LayoutHeader
                    type='basic'
                    section={t('general')}
                    title={t('activitySettings')}
                />
            }
        >
            <ActionCard
                text={t('showLikeHistory')}
                hasSwitch
                toggleActive={userData.show_liked_history}
                toggleFn={() => {
                    activitySettingsMutation.mutate({
                        showLikeHistory: !userData.show_liked_history,
                        showWatchedHistory: userData.show_watched_history
                    })
                }}
                icon={<spriteIcons.IconHeartHole />}
                iconSize='small'
                absFix
            />
{/*             <ActionCard
                text={t('showWatchHistory')}
                hasSwitch
                toggleActive={userData.show_watched_history}
                toggleFn={() => {
                    activitySettingsMutation.mutate({
                        showLikeHistory: userData.show_liked_history,
                        showWatchedHistory: !userData.show_watched_history
                    })
                }}
                icon={<spriteIcons.IconPlayButtonClock />}
                iconSize='small'
                absFix
            /> */}
        </WithHeaderSection>
    )
}
